import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import IssueDeliveryDatePage from "../../../components/SidebarMenuComponents/OtherComponent/IssueDeliveryDatePage";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function IssueDeliveryDate() {
    const location = useLocation();
    const issueDeliveryDate = location.state;
    return (
        <Page title="Issue Delivery Date| tiketic" >
          
            <StickyHeader title="Issue Delivery Date" />

            <ContentStyle>
                <IssueDeliveryDatePage issueDeliveryDate={issueDeliveryDate} />
            </ContentStyle>
        </Page>
    );
}

